(function() {
  function els(ids) {
    return ids.map(function(id){ return document.getElementById(id); }).filter(Boolean);
  }
  /* Both mobile (…Mobile) and desktop element sets */
  var sizeGrids = els(['lfSizes', 'lfSizesMobile']);
  var addBtns = els(['lfAddBtn', 'lfAddBtnMobile']);
  var buyBtns = els(['lfBuyNowBtn', 'lfBuyNowBtnMobile']);
  var priceEls = els(['lfPrice', 'lfPriceMobile']);
  var stockEls = els(['lfStock', 'lfStockMobile']);
  var stockTexts = els(['lfStockText', 'lfStockTextMobile']);
  var prepaidEls = els(['lfPrepaidPrice', 'lfPrepaidPriceMobile']);
  var sizeErrorEls = els(['lfSizeError', 'lfSizeErrorMobile']);

  function showSizeError() {
    sizeErrorEls.forEach(function(el){ el.hidden = false; });
    var grid = sizeGrids.filter(function(g){ return g.offsetParent !== null; })[0] || sizeGrids[0];
    if (grid && grid.scrollIntoView) grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function hideSizeError() {
    sizeErrorEls.forEach(function(el){ el.hidden = true; });
  }

  function updateStock(qty) {
    var n = parseInt(qty) || 0;
    var show = n > 0 && n <= 10;
    stockEls.forEach(function(el) { el.style.display = show ? 'inline-flex' : 'none'; });
    if (show) {
      stockTexts.forEach(function(el) { el.textContent = n <= 3 ? 'Almost Gone' : 'Last Few Left'; });
    }
  }

  sizeGrids.forEach(function(sizeGrid) {
    sizeGrid.querySelectorAll('.lf-pdp__size:not(.is-unavailable)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        sizeGrid.querySelectorAll('.lf-pdp__size').forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        hideSizeError();
        var vid = btn.dataset.variantId;
        var price = btn.dataset.price;
        var available = btn.dataset.available === 'true';
        var inventory = btn.dataset.inventory;
        addBtns.forEach(function(b){ b.dataset.variantId = vid; });
        buyBtns.forEach(function(b){ b.dataset.variantId = vid; });
        priceEls.forEach(function(p){ p.textContent = price; });
        updateStock(inventory);
        if (prepaidEls.length) {
          var rawPrice = parseInt(price.replace(/[^0-9]/g, '')) || 0;
          var prepaid = Math.round(rawPrice * 0.95);
          prepaidEls.forEach(function(el) {
            el.textContent = '\u20B9' + prepaid.toLocaleString('en-IN');
          });
        }
        addBtns.forEach(function(b){
          if (available) { b.disabled = false; b.textContent = 'Add to Cart'; }
          else { b.disabled = true; b.textContent = 'Sold Out'; }
        });
        buyBtns.forEach(function(b){
          if (available) { b.disabled = false; b.textContent = 'Buy Now'; }
          else { b.disabled = true; b.textContent = 'Sold Out'; }
        });
      });
    });
  });

  /* Bundle */
  var bundleProducts = document.querySelectorAll('.lf-bundle__product');
  var bundleAddBtns = els(['lfBundleAddBtn', 'lfBundleAddBtnMobile']);
  var selectedSocks = [];

  function updateBundleUI() {
    /* Buttons keep their static "Add Set \u2014 \u20B9X" label; we only enable/disable them. */
    bundleAddBtns.forEach(function(b) { b.disabled = selectedSocks.length === 0; });
  }

  bundleProducts.forEach(function(p) {
    p.addEventListener('click', function() {
      var vid = p.dataset.variantId;
      var color = p.dataset.color;
      var wasSelected = p.classList.contains('is-selected');
      /* Single-select: clear any previously chosen sock first */
      bundleProducts.forEach(function(b) { b.classList.remove('is-selected'); });
      selectedSocks = [];
      if (wasSelected) {
        bundleAddBtns.forEach(function(b) { b.removeAttribute('data-selected-variant'); });
      } else {
        p.classList.add('is-selected');
        selectedSocks.push({ id: vid, color: color });
        bundleAddBtns.forEach(function(b) { b.setAttribute('data-selected-variant', vid); });
      }
      updateBundleUI();
    });
  });

  function getBundleItems() {
    return selectedSocks.map(function(s) {
      return {
        id: parseInt(s.id),
        quantity: 1,
        properties: { '_bundle_with': document.querySelector('.lf-pdp').dataset.productTitle }
      };
    });
  }

  bundleAddBtns.forEach(function(bAdd) {
    bAdd.addEventListener('click', function() {
      var socksVariantId = this.getAttribute('data-selected-variant');
      var selectedSize = document.querySelector('.lf-pdp__size.is-selected');
      var mainVariantId = selectedSize
        ? selectedSize.getAttribute('data-variant-id')
        : (addBtns[0] ? addBtns[0].dataset.variantId : '');

      if (!socksVariantId) return;
      if (!mainVariantId) {
        showSizeError();
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(mainVariantId), quantity: 1 },
            { id: parseInt(socksVariantId), quantity: 1 }
          ]
        })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (typeof renderCartDrawer === 'function') renderCartDrawer();
        if (typeof openCartDrawer === 'function') openCartDrawer();
      })
      .catch(function(e) { console.error('Bundle add failed', e); });
    });
  });

  function doAddToCart(btn) {
    if (btn.disabled) return;
    var vid = btn.dataset.variantId;
    if (!vid) { showSizeError(); return; }
    hideSizeError();

    var addCount = 1 + selectedSocks.length;

    var galleryImg = document.querySelector('.lf-pdp__img > img, .lf-pdp__photo--indoor');
    if (window.LF && window.LF.flyToCart && galleryImg) {
      window.LF.flyToCart(galleryImg, btn);
    }

    var c = document.getElementById('cartBadge');
    if (c) {
      c.textContent = (parseInt(c.textContent) || 0) + addCount;
      c.style.display = 'flex';
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Added';
    setTimeout(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1400);

    var items = [{ id: parseInt(vid), quantity: 1 }];
    var bundleItems = getBundleItems();
    items = items.concat(bundleItems);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (selectedSocks.length > 0) {
        selectedSocks = [];
        bundleProducts.forEach(function(p) { p.classList.remove('is-selected'); });
        updateBundleUI();
      }
      if (window.LF && typeof window.LF.openCartDrawer === 'function') window.LF.openCartDrawer();
      else if (typeof renderCartDrawer === 'function') renderCartDrawer();
    })
    .catch(function() {
      if (c) {
        var newVal = (parseInt(c.textContent) || 0) - addCount;
        c.textContent = newVal;
        if (newVal <= 0) c.style.display = 'none';
      }
      btn.textContent = originalText;
      btn.disabled = false;
    });
  }

  addBtns.forEach(function(b) { b.addEventListener('click', function() { doAddToCart(b); }); });

  /* Build the same checkout form the cart drawer uses (POST /cart name=checkout) and
     CLICK its submit button rather than calling form.submit(). Razorpay Magic Checkout
     listens for clicks on form[action="/cart"] [type="submit"][name="checkout"]; a
     programmatic submit fires no click, so it went to Shopify's checkout first and
     Razorpay second. If Magic isn't loaded, the click still submits natively. */
  function goToCheckout() {
    var form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', '/cart');
    form.style.display = 'none';
    var submit = document.createElement('button');
    submit.setAttribute('type', 'submit');
    submit.setAttribute('name', 'checkout');
    submit.value = '';
    form.appendChild(submit);
    document.body.appendChild(form);
    submit.click();
  }

  /* Buy Now — add selected variant, then go straight to checkout */
  function doBuyNow(btn) {
    if (btn.disabled) return;
    var vid = btn.dataset.variantId;
    if (!vid) { showSizeError(); return; }
    hideSizeError();
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Processing…';
    var items = [{ id: parseInt(vid), quantity: 1 }].concat(getBundleItems());
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function() {
      goToCheckout();
      /* Razorpay opens as a popup over this page, so a shopper who closes it is
         still here — reset the button and refresh the bag count. */
      btn.disabled = false;
      btn.textContent = originalText;
      if (typeof renderCartDrawer === 'function') renderCartDrawer();
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = originalText;
    });
  }
  buyBtns.forEach(function(b) { b.addEventListener('click', function() { doBuyNow(b); }); });

  /* Gallery dot tracking */
  var gallery = document.getElementById('lfGallery');
  var dots = document.querySelectorAll('.lf-pdp__dot');
  if (gallery && dots.length > 0) {
    var scrollTimer = null;
    gallery.addEventListener('scroll', function() {
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(function() {
        var idx = Math.round(gallery.scrollLeft / gallery.offsetWidth);
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
      });
    }, { passive: true });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(dot.dataset.index);
        gallery.scrollTo({ left: gallery.offsetWidth * idx, behavior: 'smooth' });
      });
    });
  }

  /* Photochromic label */
  var photoLabel = document.getElementById('lfPhotoLabel');
  if (photoLabel) {
    var pendingTimers = [];
    function runLabelCycle() {
      pendingTimers.forEach(clearTimeout);
      pendingTimers = [];
      photoLabel.textContent = 'In Shade';
      pendingTimers.push(setTimeout(function() { photoLabel.textContent = 'In Sunlight'; }, 3000));
      pendingTimers.push(setTimeout(function() { photoLabel.textContent = 'In Shade'; }, 7000));
    }
    runLabelCycle();
    setInterval(runLabelCycle, 8000);
  }

  /* Accordions */
  document.querySelectorAll('.lf-pdp__acc-trigger').forEach(function(t) {
    t.addEventListener('click', function() {
      var item = t.parentElement;
      var body = item.querySelector('.lf-pdp__acc-body');
      var inner = body.querySelector('.lf-pdp__acc-inner');
      if (item.classList.contains('is-open')) {
        body.style.maxHeight = '0';
        item.classList.remove('is-open');
      } else {
        body.style.maxHeight = inner.scrollHeight + 'px';
        item.classList.add('is-open');
      }
    });
  });
})();

function lfOpenSizeChart() {
  document.getElementById('lfScOverlay').classList.add('is-open');
  document.getElementById('lfScPopup').classList.add('is-open');
  document.body.style.overflow = 'hidden';
}
function lfCloseSizeChart() {
  document.getElementById('lfScOverlay').classList.remove('is-open');
  document.getElementById('lfScPopup').classList.remove('is-open');
  document.body.style.overflow = '';
}
